import React, {Component} from 'react';
import SedeAnatomica from './Sezioni/SedeAnatomica';
import Utils from '../../../../utils/Utils';
import CollettivitaPreMalattia from './Sezioni/CollettivitaPreMalattia';
import ViaggiSoggiorni from './Sezioni/ViaggiSoggiorni';
import Vaccinazioni from './Sezioni/Vaccinazioni';
import Contatti from './Sezioni/Contatti';
import Trasmissione from './Sezioni/Trasmissione';
import Veicolo from './Sezioni/Veicolo';
import InfoClinicheAggiuntive from './Sezioni/InfoClinicheAggiuntive';
import Terapia from './Sezioni/Terapia';
import FarmacoResistenza from './Sezioni/FarmacoResistenza';
import EventiCorrelabili from './Sezioni/EventiCorrelabili';
import MalformazioniNeonatali from './Sezioni/MalformazioniNeonatali';
import InfoGravidanza from './Sezioni/InfoGravidanza';
import InfoNato from './Sezioni/InfoNato';
import InfoMadre from './Sezioni/InfoMadre';
import PatologieCroniche from './Sezioni/PatologieCroniche';
import AltreInformazioni from './Sezioni/AltreInformazioni';
import {withTranslation} from "react-i18next";
import CollettivitaPostMalattia from "./Sezioni/CollettivitaPostMalattia";
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import toasterConfig from "../../../../config/toasterConfig";
import history from "../../../../utils/History";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import {states} from "../../States/States";
import styles from "./DatiSpecifici.module.css";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../utils/Ruoli";
import Modale from "../../../../components/modale/Modale.js";


class DatiSpecifici extends Component {

    state = {
        listaSezioni: [],
        sezioni: [],
        infoMalattia: {},
        disabledConfermaProsegui: false,
        datiSpecifici: {
            sedeAnatomica: {},
            viaggiESoggiorni: {},
            veicolo: {},
            infoGravidanza: {},
            terapia: {},
            collettivitaPreMalattia: {},
            collettivitaPostMalattia: {},
            infoClinicheAggiuntive: {},
            malformazioniNeonatali: {},
            infoNato: {},
            patologieCroniche: {},
            infoMadre: {},
            trasmissione: {},
            eventiCorrelabili: {},
            contatto: {},
            farmacoResistenza: {},
            vaccinazioni: {},
            altreInformazioni: {}
        },
        oggettiPerBackend: {
            sedeAnatomica: {},
            viaggiESoggiorni: {},
            veicolo: {},
            infoGravidanza: {},
            terapia: {},
            collettivitaPreMalattia: {},
            collettivitaPostMalattia: {},
            infoClinicheAggiuntive: {},
            malformazioniNeonatali: {},
            infoNato: {},
            patologieCroniche: {},
            infoMadre: {},
            trasmissione: {},
            eventiCorrelabili: {},
            contatto: {},
            farmacoResistenza: {},
            vaccinazioni: {},
            altreInformazioni: {}
        },
        validate: {
            validateViaggiESoggiorni: {},
            validateInfoGravidanza: {},
            validateTerapia: {},
            validateInfoClinicheAggiuntive: {},
            validateMalformazioniNeonatali: {},
            validateInfoMadre: {},
            validateFarmacoResistenza: {},
            validateEventiCorrelabili: {},
            validateInfoNato: {},
            validateContatto: {},
            validateCollettivitaPre: {},
            validateCollettivitaPost: {},
            validateVeicolo: {},
            validateVaccinazioni: {},
            validateAltreInformazioni: {}
        },

        malattiePerCodice: JSON.parse(sessionStorage.getItem("malattiePerCodice")),
        mostraPopUpIniziale:true
    }

    constructor(props) {
        super(props);
        this.renderSwitch = this.renderSwitch.bind(this)
        this.setSedeAnatomica = this.setSedeAnatomica.bind(this);
        this.setViaggiESoggiorni = this.setViaggiESoggiorni.bind(this)
        this.setInfoGravidanza = this.setInfoGravidanza.bind(this);
        this.setTerapia = this.setTerapia.bind(this);
        this.setColletivitaPreMalattia = this.setColletivitaPreMalattia.bind(this)
        this.setColletivitaPostMalattia = this.setColletivitaPostMalattia.bind(this)
        this.setInfoClinicheAggiuntive = this.setInfoClinicheAggiuntive.bind(this)
        this.setMalformazioniNeonatali = this.setMalformazioniNeonatali.bind(this)
        this.setInfoNato = this.setInfoNato.bind(this)
        this.setPatologieCroniche = this.setPatologieCroniche.bind(this)
        this.setInfoMadre = this.setInfoMadre.bind(this)
        this.setFarmacoResistenza = this.setFarmacoResistenza.bind(this);
        this.setTrasmissione = this.setTrasmissione.bind(this)
        this.setContatti = this.setContatti.bind(this)
        this.setVeicolo = this.setVeicolo.bind(this)
        this.setVaccinazioni = this.setVaccinazioni.bind(this)
        this.setAltreInformazioni = this.setAltreInformazioni.bind(this)
        this.validate = this.validate.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this._back = this._back.bind(this)
        this.setEventiCorrelabili = this.setEventiCorrelabili.bind(this);
        this.callToPutSegnalazione = this.callToPutSegnalazione.bind(this);
        this.callToConfermaDati = this.callToConfermaDati.bind(this);
        this.nextStep = this.nextStep.bind(this)
        this.controlloDatiToaster = this.controlloDatiToaster.bind(this)
        this.closePopUp = this.closePopUp.bind(this)
    }

    componentDidMount() {
        this.setState({
            mostraPopUpIniziale:!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati
        })
        ToasterSingleton.instance().sottoscrizione(this)

        if (this.props.infoMalattia) {
            this.setState({infoMalattia: this.props.infoMalattia})
        }
        this.setState({listaSezioni: this.props.listaSezioni, sezioni: this.renderSwitch(this.props.listaSezioni)})
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
        ToasterSingleton.instance().pulisci()
    }

    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({pathname: path});
    }


    nextStep(segnalazione, segnalazioneCopia) {
        let path = "/wizardSegnalazione";
        history.push({
            pathname: path,
            state: {
                currentState: states.SCHEDA_SPECIALE,
                segnalazione: segnalazione,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti: Utils.getCompletezzaStep(segnalazione)
            }
        })
    }

    onClickValidazione() {
        let jsonInsert = this.props.segnalazione

        jsonInsert.statoValidazione = OggettiUtili.statoValidazioneByLabel.Validata.codice
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner)

        let path = "/ricercaSegnalazioni"
        history.push({
            pathname: path,
            state: {
                currentState: states.HOME,
            }
        })
    }

    onSubmit(e) {
        e.preventDefault()
    }

    aggiungiToaster(text, textList) {

        ToasterSingleton.instance().aggiuntaToaster(
            {
                type: toasterConfig.types.confirm,
                text: text,
                timestamp: Date.now(),
                textList: textList
            });
    }

    setSedeAnatomica(sedeAnatomica, oggettoBackend) {
        let datiSpecifici = this.state.datiSpecifici
        datiSpecifici.sedeAnatomica = sedeAnatomica
        let oggettoPerBackend = this.state.oggettiPerBackend
        oggettoPerBackend.sedeAnatomica = oggettoBackend

        if (sedeAnatomica !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettoPerBackend})
        } else if (sedeAnatomica !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (sedeAnatomica === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettoPerBackend})
        }

    }

    setInfoGravidanza(gravidanza, validateInfoGravidanza, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        validate.validateInfoGravidanza = validateInfoGravidanza
        datiSpecifici.infoGravidanza = gravidanza
        oggetto.infoGravidanza = oggettoBackend

        if (gravidanza !== undefined && validateInfoGravidanza !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (gravidanza !== undefined && validateInfoGravidanza !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (gravidanza !== undefined && validateInfoGravidanza === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (gravidanza === undefined && validateInfoGravidanza !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (gravidanza !== undefined && validateInfoGravidanza === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (gravidanza === undefined && validateInfoGravidanza !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (gravidanza === undefined && validateInfoGravidanza === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setTerapia(terapie, validateTerapia, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.terapia = terapie
        validate.validateTerapia = validateTerapia
        oggetto.terapia = oggettoBackend

        if (terapie !== undefined && validateTerapia !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (terapie !== undefined && validateTerapia !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (terapie !== undefined && validateTerapia === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (terapie === undefined && validateTerapia !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (terapie !== undefined && validateTerapia === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (terapie === undefined && validateTerapia !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (terapie === undefined && validateTerapia === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setVaccinazioni(vaccinazioni, validateVaccinazioni, oggettoBackend) {

        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.vaccinazioni = vaccinazioni
        validate.validateVaccinazioni = validateVaccinazioni
        oggetto.vaccinazioni = oggettoBackend

        if (vaccinazioni !== undefined && validateVaccinazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (vaccinazioni !== undefined && validateVaccinazioni !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (vaccinazioni !== undefined && validateVaccinazioni === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (vaccinazioni === undefined && validateVaccinazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (vaccinazioni !== undefined && validateVaccinazioni === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (vaccinazioni === undefined && validateVaccinazioni !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (vaccinazioni === undefined && validateVaccinazioni === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }


    setViaggiESoggiorni(viaggiESoggiorni, validateViaggiESoggiorni, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggettoPerBackend = this.state.oggettiPerBackend

        datiSpecifici.viaggiESoggiorni = viaggiESoggiorni
        validate.validateViaggiESoggiorni = validateViaggiESoggiorni
        oggettoPerBackend.viaggiESoggiorni = oggettoBackend

        if (oggettoBackend !== undefined && viaggiESoggiorni !== undefined && validateViaggiESoggiorni !== undefined) {

            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggettoPerBackend})
        } else if (oggettoBackend !== undefined && viaggiESoggiorni !== undefined && validateViaggiESoggiorni === undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettoPerBackend})

        } else if (oggettoBackend !== undefined && viaggiESoggiorni === undefined && validateViaggiESoggiorni !== undefined) {
            this.setState({oggettiPerBackend: oggettoPerBackend, validate: validate})

        } else if (oggettoBackend === undefined && viaggiESoggiorni !== undefined && validateViaggiESoggiorni !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})

        } else if (oggettoBackend !== undefined && viaggiESoggiorni === undefined && validateViaggiESoggiorni === undefined) {
            this.setState({oggettiPerBackend: oggettoPerBackend})

        } else if (oggettoBackend === undefined && viaggiESoggiorni !== undefined && validateViaggiESoggiorni === undefined) {
            this.setState({datiSpecifici: datiSpecifici})

        } else if (oggettoBackend === undefined && viaggiESoggiorni === undefined && validateViaggiESoggiorni !== undefined) {
            this.setState({validate: validate})

        }

    }

    setColletivitaPreMalattia(collettivitaPre, validateCollettivitaPre, oggettoBackend) {
        let validate = this.state.validate
        let oggettiPerBackend = this.state.oggettiPerBackend
        let datiSpecifici = this.state.datiSpecifici
        datiSpecifici.collettivitaPreMalattia = collettivitaPre
        oggettiPerBackend.collettivitaPreMalattia = oggettoBackend
        validate.validateCollettivitaPre = validateCollettivitaPre
        if (collettivitaPre !== undefined && validateCollettivitaPre !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivitaPre !== undefined && validateCollettivitaPre !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (collettivitaPre !== undefined && validateCollettivitaPre === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivitaPre === undefined && validateCollettivitaPre !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivitaPre !== undefined && validateCollettivitaPre === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (collettivitaPre === undefined && validateCollettivitaPre !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (collettivitaPre === undefined && validateCollettivitaPre === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettiPerBackend})
        }

    }

    setColletivitaPostMalattia(collettivita, validateCollettivita, oggettoBackend) {
        let validate = this.state.validate
        let oggettiPerBackend = this.state.oggettiPerBackend
        let datiSpecifici = this.state.datiSpecifici
        validate.validateCollettivitaPost = validateCollettivita
        oggettiPerBackend.collettivitaPostMalattia = oggettoBackend
        datiSpecifici.collettivitaPostMalattia = collettivita
        if (collettivita !== undefined && validateCollettivita !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivita !== undefined && validateCollettivita !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (collettivita !== undefined && validateCollettivita === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivita === undefined && validateCollettivita !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (collettivita !== undefined && validateCollettivita === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (collettivita === undefined && validateCollettivita !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (collettivita === undefined && validateCollettivita === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettiPerBackend})
        }

    }


    setInfoClinicheAggiuntive(infoClinicheAggiuntive, validateInfoClinicheAggiuntive, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.infoClinicheAggiuntive = infoClinicheAggiuntive
        validate.validateInfoClinicheAggiuntive = validateInfoClinicheAggiuntive
        oggetto.infoClinicheAggiuntive = oggettoBackend

        if (infoClinicheAggiuntive !== undefined && validateInfoClinicheAggiuntive !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (infoClinicheAggiuntive !== undefined && validateInfoClinicheAggiuntive !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (infoClinicheAggiuntive !== undefined && validateInfoClinicheAggiuntive === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (infoClinicheAggiuntive === undefined && validateInfoClinicheAggiuntive !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (infoClinicheAggiuntive !== undefined && validateInfoClinicheAggiuntive === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (infoClinicheAggiuntive === undefined && validateInfoClinicheAggiuntive !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (infoClinicheAggiuntive === undefined && validateInfoClinicheAggiuntive === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setMalformazioniNeonatali(malformazioniNeonatali, validateMalformazioni, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        validate.validateMalformazioniNeonatali = validateMalformazioni
        datiSpecifici.malformazioniNeonatali = malformazioniNeonatali
        oggetto.malformazioniNeonatali = oggettoBackend

        if (malformazioniNeonatali !== undefined && validateMalformazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (malformazioniNeonatali !== undefined && validateMalformazioni !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (malformazioniNeonatali !== undefined && validateMalformazioni === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (malformazioniNeonatali === undefined && validateMalformazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (malformazioniNeonatali !== undefined && validateMalformazioni === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (malformazioniNeonatali === undefined && validateMalformazioni !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (malformazioniNeonatali === undefined && validateMalformazioni === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setInfoNato(infoNato, validateInfoNato, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        validate.validateInfoNato = validateInfoNato
        datiSpecifici.infoNato = infoNato
        oggetto.infoNato = oggettoBackend

        if (infoNato !== undefined && validateInfoNato !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (infoNato !== undefined && validateInfoNato !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (infoNato !== undefined && validateInfoNato === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (infoNato === undefined && validateInfoNato !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (infoNato !== undefined && validateInfoNato === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (infoNato === undefined && validateInfoNato !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (infoNato === undefined && validateInfoNato === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setPatologieCroniche(patologieCroniche, oggettoBackend) {
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.patologieCroniche = patologieCroniche
        oggetto.patologieCroniche = oggettoBackend
        if (patologieCroniche !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (patologieCroniche !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (patologieCroniche === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setInfoMadre(infoMadre, validateInfoMadre, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.infoMadre = infoMadre
        validate.validateInfoMadre = validateInfoMadre
        oggetto.infoMadre = oggettoBackend

        if (infoMadre !== undefined && validateInfoMadre !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (infoMadre !== undefined && validateInfoMadre !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (infoMadre !== undefined && validateInfoMadre === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (infoMadre === undefined && validateInfoMadre !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (infoMadre !== undefined && validateInfoMadre === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (infoMadre === undefined && validateInfoMadre !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (infoMadre === undefined && validateInfoMadre === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }

    setTrasmissione(trasmissione, oggettoBackend) {
        let datiSpecifici = this.state.datiSpecifici
        let oggettiPerBackend = this.state.oggettiPerBackend
        datiSpecifici.trasmissione = trasmissione
        oggettiPerBackend.trasmissione = oggettoBackend
        if (trasmissione !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettiPerBackend})
        } else if (trasmissione !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (trasmissione === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettiPerBackend})
        }

    }

    setContatti(contatti, validateContatto, oggettoBackend) {
        let validate = this.state.validate
        validate.validateContatto = validateContatto
        let datiSpecifici = this.state.datiSpecifici
        datiSpecifici.contatto = contatti
        let oggettoPerBackend = this.state.oggettiPerBackend
        oggettoPerBackend.contatto = oggettoBackend
        if (contatti !== undefined && validateContatto !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggettoPerBackend})
        } else if (contatti !== undefined && validateContatto !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (contatti !== undefined && validateContatto === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettoPerBackend})
        } else if (contatti === undefined && validateContatto !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggettoPerBackend})
        } else if (contatti !== undefined && validateContatto === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (contatti === undefined && validateContatto !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (contatti === undefined && validateContatto === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettoPerBackend})
        }

    }

    setVeicolo(veicolo, validateVeicolo, oggettoBackend) {
        let validate = this.state.validate
        let oggettiPerBackend = this.state.oggettiPerBackend
        let datiSpecifici = this.state.datiSpecifici
        datiSpecifici.veicolo = veicolo
        validate.validateVeicolo = validateVeicolo
        oggettiPerBackend.veicolo = oggettoBackend
        if (veicolo !== undefined && validateVeicolo !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (veicolo !== undefined && validateVeicolo !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (veicolo !== undefined && validateVeicolo === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggettiPerBackend})
        } else if (veicolo === undefined && validateVeicolo !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggettiPerBackend})
        } else if (veicolo !== undefined && validateVeicolo === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (veicolo === undefined && validateVeicolo !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (veicolo === undefined && validateVeicolo === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggettiPerBackend})
        }

    }

    setFarmacoResistenza(farmacoResistenza, validateFarmacoResistenza, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend
        datiSpecifici.farmacoResistenza = farmacoResistenza
        validate.validateFarmacoResistenza = validateFarmacoResistenza
        oggetto.farmacoResistenza = oggettoBackend

        if (farmacoResistenza !== undefined && validateFarmacoResistenza !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (farmacoResistenza !== undefined && validateFarmacoResistenza !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (farmacoResistenza !== undefined && validateFarmacoResistenza === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (farmacoResistenza === undefined && validateFarmacoResistenza !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (farmacoResistenza !== undefined && validateFarmacoResistenza === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (farmacoResistenza === undefined && validateFarmacoResistenza !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (farmacoResistenza === undefined && validateFarmacoResistenza === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }

    }


    setEventiCorrelabili(eventiCorrelabili, validateEventiCorrelabili, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend

        validate.validateEventiCorrelabili = validateEventiCorrelabili
        datiSpecifici.eventiCorrelabili = eventiCorrelabili
        oggetto.eventiCorrelabili = oggettoBackend

        if (eventiCorrelabili !== undefined && validateEventiCorrelabili !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (oggettoBackend !== undefined && eventiCorrelabili !== undefined && validateEventiCorrelabili === undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (oggettoBackend !== undefined && eventiCorrelabili === undefined && validateEventiCorrelabili !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (oggettoBackend === undefined && eventiCorrelabili !== undefined && validateEventiCorrelabili !== undefined) {
            this.setState({validate: validate, datiSpecifici: datiSpecifici})
        } else if (oggettoBackend !== undefined && eventiCorrelabili === undefined && validateEventiCorrelabili === undefined) {
            this.setState({oggettiPerBackend: oggetto})
        } else if (oggettoBackend === undefined && eventiCorrelabili !== undefined && validateEventiCorrelabili === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (oggettoBackend === undefined && eventiCorrelabili === undefined && validateEventiCorrelabili !== undefined) {
            this.setState({validate: validate})
        }

    }

    setAltreInformazioni(altreInformazioni, validateAltreInformazioni, oggettoBackend) {
        let validate = this.state.validate
        let datiSpecifici = this.state.datiSpecifici
        let oggetto = this.state.oggettiPerBackend

        validate.validateAltreInformazioni = validateAltreInformazioni
        datiSpecifici.altreInformazioni = altreInformazioni
        oggetto.altreInformazioni = oggettoBackend

        if (altreInformazioni !== undefined && validateAltreInformazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate, oggettiPerBackend: oggetto})
        } else if (altreInformazioni !== undefined && validateAltreInformazioni !== undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici, validate: validate})
        } else if (altreInformazioni !== undefined && validateAltreInformazioni === undefined && oggettoBackend !== undefined) {
            this.setState({datiSpecifici: datiSpecifici, oggettiPerBackend: oggetto})
        } else if (altreInformazioni === undefined && validateAltreInformazioni !== undefined && oggettoBackend !== undefined) {
            this.setState({validate: validate, oggettiPerBackend: oggetto})
        } else if (altreInformazioni !== undefined && validateAltreInformazioni === undefined && oggettoBackend === undefined) {
            this.setState({datiSpecifici: datiSpecifici})
        } else if (altreInformazioni === undefined && validateAltreInformazioni !== undefined && oggettoBackend === undefined) {
            this.setState({validate: validate})
        } else if (altreInformazioni === undefined && validateAltreInformazioni === undefined && oggettoBackend !== undefined) {
            this.setState({oggettiPerBackend: oggetto})
        }
    }


    validate(clickSalvaOConferma) {

        if (this.state.validate) {
            if (!Utils.isObjectEmpty(this.state.validate.validateViaggiESoggiorni)) {
                let val = this.state.validate.validateViaggiESoggiorni.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateVaccinazioni)) {
                let val = this.state.validate.validateVaccinazioni.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateInfoClinicheAggiuntive)) {
                let val = this.state.validate.validateInfoClinicheAggiuntive.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateTerapia)) {
                let val = this.state.validate.validateTerapia.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateMalformazioniNeonatali)) {
                let val = this.state.validate.validateMalformazioniNeonatali.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateInfoGravidanza)) {
                let val = this.state.validate.validateInfoGravidanza.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateInfoNato)) {
                let val = this.state.validate.validateInfoNato.validate()
                if (val !== undefined) {
                    return
                }
            }

            if (!Utils.isObjectEmpty(this.state.validate.validateInfoMadre)) {
                let val = this.state.validate.validateInfoMadre.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateFarmacoResistenza)) {
                let val = this.state.validate.validateFarmacoResistenza.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateEventiCorrelabili)) {
                let val = this.state.validate.validateEventiCorrelabili.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateContatto)) {
                let val = this.state.validate.validateContatto.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateCollettivitaPre)) {
                let val = this.state.validate.validateCollettivitaPre.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateCollettivitaPost)) {
                let val = this.state.validate.validateCollettivitaPost.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateVeicolo)) {
                let val = this.state.validate.validateVeicolo.validate()
                if (val !== undefined) {
                    return
                }
            }
            if (!Utils.isObjectEmpty(this.state.validate.validateAltreInformazioni)) {
                let val = this.state.validate.validateAltreInformazioni.validate()
                if (val !== undefined) {
                    return
                }
            }


        }
        this.props.segnalazione["datiSpecifici"] = Utils.removeEmptyValueFromObject(this.state.oggettiPerBackend)
        let jsonInsert = this.props.segnalazione
        if (clickSalvaOConferma === 1) {
            this.callToPutSegnalazione(jsonInsert);
        } else {
            this.callToConfermaDati();
        }
    }

    callToPutSegnalazione(jsonInsert) {
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner)
    }

    callToConfermaDati() {
        this.props.showSpinner(true);
        let jsonDatiSpecifici = {datiSpecifici: this.props.segnalazione.datiSpecifici};

        SegnalazioniService.postConfermaDatiSpecifici(this.props.segnalazione.idSegnalazione, jsonDatiSpecifici)
            .then((data) => {
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    let segnalazioneSalvata = this.props.segnalazione;
                    segnalazioneSalvata["stepConfermati"] = data.data.stepConfermati;
                    if((this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && !this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale)){
                        this._back()
                    }
                    else{
                        this.nextStep(segnalazioneSalvata, this.props.segnalazioneCopia)
                    }
                }
            })
            .catch(() => {
                this.props.showSpinner(false);
            })
    }


    controlloDatiToaster(tipo){
        ToasterSingleton.instance().pulisci()
        let textList = []

        if(!Utils.isEmpty(this.state.datiSpecifici.collettivitaPreMalattia) && this.state.datiSpecifici.collettivitaPreMalattia.corretto && this.state.datiSpecifici.collettivitaPreMalattia.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.collettivitaPreMalattia.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.contatto) && this.state.datiSpecifici.contatto.corretto && this.state.datiSpecifici.contatto.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.contatto.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.eventiCorrelabili) && this.state.datiSpecifici.eventiCorrelabili.corretto && this.state.datiSpecifici.eventiCorrelabili.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.eventiCorrelabili.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.farmacoResistenza) && this.state.datiSpecifici.farmacoResistenza.corretto && this.state.datiSpecifici.farmacoResistenza.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.farmacoResistenza.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.infoClinicheAggiuntive) && this.state.datiSpecifici.infoClinicheAggiuntive.corretto && this.state.datiSpecifici.infoClinicheAggiuntive.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.infoClinicheAggiuntive.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.infoGravidanza) && this.state.datiSpecifici.infoGravidanza.corretto && this.state.datiSpecifici.infoGravidanza.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.infoGravidanza.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.infoMadre) && this.state.datiSpecifici.infoMadre.corretto && this.state.datiSpecifici.infoMadre.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.infoMadre.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.infoNato) && this.state.datiSpecifici.infoNato.corretto && this.state.datiSpecifici.infoNato.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.infoNato.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.patologieCroniche) && this.state.datiSpecifici.patologieCroniche.corretto && this.state.datiSpecifici.patologieCroniche.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.patologieCroniche.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.sedeAnatomica) && this.state.datiSpecifici.sedeAnatomica.corretto && this.state.datiSpecifici.sedeAnatomica.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.sedeAnatomica.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.altreInformazioni) && this.state.datiSpecifici.altreInformazioni.corretto && this.state.datiSpecifici.altreInformazioni.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.altreInformazioni.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.terapia) && this.state.datiSpecifici.terapia.corretto && this.state.datiSpecifici.terapia.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.terapia.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.trasmissione) && this.state.datiSpecifici.trasmissione.corretto && this.state.datiSpecifici.trasmissione.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.trasmissione.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.veicolo) && this.state.datiSpecifici.veicolo.corretto && this.state.datiSpecifici.veicolo.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.veicolo.corretto))
        }
        if(!Utils.isEmpty(this.state.datiSpecifici.viaggiESoggiorni) && this.state.datiSpecifici.viaggiESoggiorni.corretto && this.state.datiSpecifici.viaggiESoggiorni.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(this.state.datiSpecifici.viaggiESoggiorni.corretto))
        }

        if(textList.length > 0 && tipo === "1") return this.aggiungiToaster(textList, true)
        else if(textList.length > 0 && tipo === "2" &&
            this.props.segnalazioneCopia.stepConfermati &&
            this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati){
            return this.aggiungiToaster(textList, true)
        }
        else{
            if(tipo === "1"){
                if(this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && !this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale){
                    this.validate(0)
                }
                else if(( this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))){
                    this.nextStep(this.props.segnalazioneCopia, this.props.segnalazioneCopia)
                }
                else{
                    this.validate(0)
                }
            }
            else if(tipo === "2"){
                this.validate(1)
            }
        }

    }

    renderSwitch(res) {
        this.props.showSpinner(true);
        let boxSezioni = [];
        for (let i = 0; i < res.length; i++) {
            switch (res[i].idSezione) {
                case 8:
                    boxSezioni.push(<SedeAnatomica
                        malattia={this.props.datiPaziente.malattia}
                        setSedeAnatomica={this.setSedeAnatomica}
                        sedeAnatomica={this.state.datiSpecifici.sedeAnatomica}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />);
                    break;
                case 6:
                    boxSezioni.push(<ViaggiSoggiorni
                        malattia={this.props.datiPaziente.malattia}
                        setViaggiESoggiorni={this.setViaggiESoggiorni}
                        viaggiESoggiorni={this.state.datiSpecifici.viaggiESoggiorni}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);
                    break;
                case 11:
                    boxSezioni.push(<Vaccinazioni
                        vaccinazioni={this.state.datiSpecifici.vaccinazioni}
                        setVaccinazioni={this.setVaccinazioni}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);
                    break;
                case 4:
                    boxSezioni.push(<Contatti
                        malattia={this.props.datiPaziente.malattia}
                        setContatto={this.setContatti}
                        aggiungiToaster={this.aggiungiToaster}
                        contatto={this.state.datiSpecifici.contatto}
                        segnalazioneDatiSpecificiCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);

                    break;
                case 2:
                    boxSezioni.push(<CollettivitaPreMalattia
                        malattia={this.props.datiPaziente.malattia}
                        setCollettivitaPreMalattia={this.setColletivitaPreMalattia}
                        collettivitaPreMalattia={this.state.datiSpecifici.collettivitaPreMalattia}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                        aggiungiToaster={this.aggiungiToaster}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);
                    break;
                case 3:
                    boxSezioni.push(<CollettivitaPostMalattia
                        malattia={this.props.datiPaziente.malattia}
                        setCollettivitaPostMalattia={this.setColletivitaPostMalattia}
                        aggiungiToaster={this.aggiungiToaster}
                        collettivitaPostMalattia={this.state.datiSpecifici.collettivitaPostMalattia}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    />)
                    break;
                case 10:
                    boxSezioni.push(<Trasmissione
                        malattia={this.props.datiPaziente.malattia}
                        setTrasmissione={this.setTrasmissione}
                        trasmissione={this.state.trasmissione}
                        segnalazioneDatiSpecificiCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);
                    break;
                case 12:
                    boxSezioni.push(<Veicolo
                        malattia={this.props.datiPaziente.malattia}
                        setVeicolo={this.setVeicolo}
                        aggiungiToaster={this.aggiungiToaster}
                        veicolo={this.state.datiSpecifici.veicolo}
                        segnalazioneDatiSpecificiCopia={this.props.segnalazioneCopia}
                        infoMalattia={this.props.infoMalattia && this.props.infoMalattia["veicoli"] ? this.props.infoMalattia["veicoli"] : ""}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />);
                    break;
                case 1:
                    boxSezioni.push(<InfoClinicheAggiuntive
                        malattia={this.props.datiPaziente.malattia}
                        setInfoClinicheAggiuntive={this.setInfoClinicheAggiuntive}
                        infoClinicheAggiuntive={this.state.datiSpecifici.infoClinicheAggiuntive}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />)
                    break;
                case 9:
                    boxSezioni.push(<Terapia
                        malattia={this.props.datiPaziente.malattia}
                        setTerapia={this.setTerapia}
                        terapia={this.state.datiSpecifici.terapia}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />)
                    break;
                case 7:
                    boxSezioni.push(<FarmacoResistenza
                        malattia={this.props.datiPaziente.malattia}
                        setFarmacoResistenza={this.setFarmacoResistenza}
                        farmacoResistenza={this.state.datiSpecifici.farmacoResistenza}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        showSpinner={this.props.showSpinner}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />)
                    break;
                case 13:
                    boxSezioni.push(<EventiCorrelabili
                        malattia={this.props.datiPaziente.malattia}
                        setEventiCorrelabili={this.setEventiCorrelabili}
                        eventiCorrelabili={this.state.datiSpecifici.eventiCorrelabili}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />)
                    break;
                case 15:
                    boxSezioni.push(<MalformazioniNeonatali
                        malattia={this.props.datiPaziente.malattia}
                        setMalformazioniNeonatali={this.setMalformazioniNeonatali}
                        malformazioniNeonatali={this.state.datiSpecifici.malformazioniNeonatali}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                    />)
                    break;
                case 16:
                    boxSezioni.push(<InfoGravidanza
                        malattia={this.props.datiPaziente.malattia}
                        setInfoGravidanza={this.setInfoGravidanza}
                        infoGravidanza={this.state.datiSpecifici.infoGravidanza}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                    />)
                    break;
                case 18:
                    boxSezioni.push(<InfoNato
                        malattia={this.props.datiPaziente.malattia}
                        setInfoNato={this.setInfoNato}
                        aggiungiToaster={this.aggiungiToaster}
                        infoNato={this.state.datiSpecifici.infoNato}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                    />)
                    break;
                case 17:
                    boxSezioni.push(<InfoMadre
                        malattia={this.props.datiPaziente.malattia}
                        setInfoMadre={this.setInfoMadre}
                        infoMadre={this.state.datiSpecifici.infoMadre}
                        aggiungiToaster={this.aggiungiToaster}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                    />)
                    break;
                case 14:
                    boxSezioni.push(<PatologieCroniche
                        malattia={this.props.datiPaziente.malattia}
                        setPatologieCroniche={this.setPatologieCroniche}
                        patologieCroniche={this.state.datiSpecifici.patologieCroniche}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                        malattiePremal = {OggettiUtili.malattiePremalCodici}
                    />)
                    break;
                case 19:
                    boxSezioni.splice(3,0,<AltreInformazioni
                        setAltreInformazioni={this.setAltreInformazioni}
                        altreInformazioni={this.state.datiSpecifici.altreInformazioni}
                        segnalazioneCopia={this.props.segnalazioneCopia}
                    />)
                    break;
            }
        }
        this.props.showSpinner(false);
        return boxSezioni;
    }


    closePopUp(){
        this.state.mostraPopUpIniziale=false;
    }
    render() {
        const { t } = this.props;
        const buttonDiv = (
            <ButtonRow
                onClickConfermaEProsegui={() => this.controlloDatiToaster("1")}
                isArchiviato={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia && (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}
                modalTextConferma={(this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale) || this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].descrizione === "Listeriosi" || this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].descrizione === "Tetano" ? "Buttons.confermaModifica" : "Buttons.chiusuraSegnalazione"}
                onClickSalva={() => this.controlloDatiToaster("2")}
                back={this._back}
                nextStep={this.props.infoMalattia.schedaSpeciale}
                validazioneMalattia={this.props.infoMalattia && !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) ? true : false}
                differenzaGiorniValidazione={this.props.segnalazioneCopia.giorniValidita &&
                    (this.props.segnalazioneCopia.giorniValidita - Utils.daysBetween(new Date(Utils.transformDateForBackend(this.props.segnalazioneCopia.dataSegnalazione)), new Date()) < 0 ? true : "")}
                onClickValidazione={() => this.onClickValidazione()}
                confermaScheda={this.props.datiCompletiECorretti[4].completo}
                segnalazioneCopia={this.props.segnalazioneCopia}
            />)

        return (
            <div>
                  {this.state.mostraPopUpIniziale && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)?
                 
                       <Modale
                           classes="btnWhite"
                           id="modaleStep4e5"
                           title="Attenzione!"
                           modalText={this.props.segnalazioneCopia.malattia==="031" || this.props.segnalazioneCopia.malattia==="0578" || this.props.segnalazioneCopia.malattia==="7710"|| this.props.segnalazioneCopia.malattia==="6475" || this.props.segnalazioneCopia.malattia==="090" || this.props.segnalazioneCopia.malattia==="7712" || this.props.segnalazioneCopia.malattia==="011" || this.props.segnalazioneCopia.malattia==="0663ZC"?t("Messages.POPUPESITO2"):t("Messages.POPUPESITO1")}
                           typeModal="modalConsenso"
                           attivazioneImmediata={true}
                           confirmFun={this.closePopUp}
                           soloModale={true} // Nasconde il bottone di attivazione
                           textButtonOk="Ho capito" // Nessun testo per il bottone OK
                           textButtonKo="" // Nessun testo per il bottone KO
                           buttonMail={true} // Nasconde i bottoni se usi questa logica nel tuo componente
                       />
                       : <div/> }
            <div
                className={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
                <form onSubmit={this.onSubmit}>
                    {ToasterSingleton.instance().renderToaster()}
                    <fieldset
                        disabled={(this.props.segnalazione && this.props.segnalazione.migrazione) || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>
                        {this.state.sezioni}
                        <div className="row" style={{paddingTop: "3rem"}}>
                            <div className="col-lg-12">
                                <div className={styles.mandatoryColor}>* Campo obbligatorio</div>
                            </div>
                        </div>
                    </fieldset>

                    {buttonDiv}
                </form>
            </div>
            </div>
        );
    }
}

export default withTranslation('common')(DatiSpecifici)
